var map = {
	"./images/emails/charge": "./app/assets/images/emails/charge.png",
	"./images/emails/charge.png": "./app/assets/images/emails/charge.png",
	"./images/emails/daily-mail": "./app/assets/images/emails/daily-mail.png",
	"./images/emails/daily-mail.png": "./app/assets/images/emails/daily-mail.png",
	"./images/emails/header-blue": "./app/assets/images/emails/header-blue.png",
	"./images/emails/header-blue.png": "./app/assets/images/emails/header-blue.png",
	"./images/emails/header-green": "./app/assets/images/emails/header-green.png",
	"./images/emails/header-green.png": "./app/assets/images/emails/header-green.png",
	"./images/emails/invitation-instructions": "./app/assets/images/emails/invitation-instructions.png",
	"./images/emails/invitation-instructions.png": "./app/assets/images/emails/invitation-instructions.png",
	"./images/emails/notify-tenant": "./app/assets/images/emails/notify-tenant.png",
	"./images/emails/notify-tenant.png": "./app/assets/images/emails/notify-tenant.png",
	"./images/emails/send-notice": "./app/assets/images/emails/send-notice.png",
	"./images/emails/send-notice.png": "./app/assets/images/emails/send-notice.png",
	"./images/emails/send-receipt": "./app/assets/images/emails/send-receipt.png",
	"./images/emails/send-receipt.png": "./app/assets/images/emails/send-receipt.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets sync recursive ^\\.\\/.*$";